const messages = {
  CHECK_SPAM: {
    TEXT: 'Please check your spam folder for an SMS from us. A handful of our customers who use Android devices have pointed out that an SMS from our platform occasionally ends up in their spam folder',
    HTML: `<p class="control has-text-centered has-text-weight-bold is-size-7 lh">_MESSAGE_</p>`
  },
  SMS_FAILED: {
    TEXT: `We seem to be having a problem sending the SMS to the mobile number you provided. Please check that you have captured your mobile number correctly.`,
    HTML: `<p class="has-text-centered is-size-7 help is-danger">_MESSAGE_</p>`
  },
  SMS_FAILED_EMAIL: {
    TEXT: `Please send an email to admin@hellopeter.com along with the following subject line: '_CODE_ - OTP Send Query' and let us know your name, mobile number and any alternate email address you may have used previously on our platform`,
    HTML: `_MESSAGE_`
  }
}
const OTP_MESSAGES = {}
for (const key in messages) {
  OTP_MESSAGES[key] = {
    TEXT: messages[key].TEXT, HTML: messages[key].HTML.replace('_MESSAGE_', messages[key].TEXT)
  }
}

export default {
  data () {
    return {
      OTP_MESSAGES,
      smsFailed: '',
      smsFailedEmail: '',
    }
  },
  methods: {
    resetSmsFailedErr () {
      this.smsFailed = ''
      this.smsFailedEmail = ''
    },
    populateSmsFailedErr (traceCode) {
      this.smsFailed = this.OTP_MESSAGES.SMS_FAILED.HTML
      this.smsFailedEmail = this.OTP_MESSAGES.SMS_FAILED_EMAIL.TEXT.replace('_CODE_', traceCode)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/otp_phone_verification.js